import axios from "axios";
const http = axios.create({
    //通过请求地址前缀
    baseURL: "/api",
    //请求超时时间
    timeout: 5000
})
http.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('isAuthenticated'); // 从 localStorage 获取 token
      if (token) {
        config.headers.Authorization = `Bearer ${token}`; // 添加 Authorization 头
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
export default http;